<template>
  <basicContainer>
    <div class="yytbgl">
      <!-- 任务详情 -->
      <avue-crud
        :data="data"
        :option="option"
        :page.sync="page"
        @on-load="onLoad"
        :search.sync="search"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
      >
      <template v-slot:menu="{type,size,row}">
          <el-button size="small" type="text" icon="el-icon-view" @click.stop="view(row)">查看</el-button>
      </template>
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      option: {
        dialogDrag: true,
        dialogClickModal: false,
        stripe: true,
        border: true,
        page: true,
        selection: false,
        align: "left",
        menuAlign: "center",
        menuWidth: 230,
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 150,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "登陆名",
            prop: "loginName",
            search: false
          },
          {
            label: "姓名",
            prop: "rwzxrxm",
            search: false
          },
          {
            label: "实际开始时间",
            prop: "sjkssj",
            search: false
          },
          {
            label: "实际完成时间",
            prop: "sjwcsj",
            search: false
          },
          {
            label: "任务名称",
            prop: "rwmc",
            search: false
          },
          {
            label: "任务评分",
            prop: "grade",
            search: false
          }
        ]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0
      },
      search: {}
    };
  },
  methods: {
    load(done) {debugger
      let loginName = this.getQueryVariable('loginName')
      let Monthy = this.getQueryVariable('Monthy')
      this.$http
        .get("/fighter-workflow-saas/performance/query", {
          params: {
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize,
            Monthy: Monthy,
            loginName: loginName,
            ...this.search
          }
        })
        .then(res => {
          this.data = res.data.records || [];
          this.page.total = res.data.total || res.data.records.length || 0;
        })
        .catch(error => {
          this.$message.error(error.msg || error.message);
        })
        .finally(() => {
          typeof done === "function" && done();
        });
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.load();
    },
    searchChange(params, done) {
      this.search = params;
      this.page.currentPage = 1;
      this.load(done);
    },
    searchReset() {
      this.search = {};
      this.page.currentPage = 1;
      this.load();
    },
    refreshChange(){
        this.load()
    },
    view(row) {
    row.businessKey = row.id
    this.$router.push({
      name: 'workFlow-view-myApply',
      query: {
        businessKey: row.businessKey,
        processInstanceId: row.processInstanceId,
        taskId: null,
        formId: this.formid,
        pageKey: 'VIEW'
      }
    })
  },
    getQueryVariable (variable){   
      var strHref = document.location.toString();    
      var intPos = strHref.indexOf("?");    
      var strRight = strHref.substr(intPos + 1); //==========获取到右边的参数部分
      var arrTmp = strRight.split("&"); //=============以&分割成数组
        for (var i = 0; i < arrTmp.length; i++) {        
          var dIntPos = arrTmp[i].indexOf("=");        
          var paraName = arrTmp[i].substr(0, dIntPos);        
          var paraData = arrTmp[i].substr(dIntPos + 1);        
          if (paraName.toUpperCase() == variable.toUpperCase()) {            
            return paraData;
          }
        }    
      }

  }
};

</script>

<style></style>
